import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";
import { SocialIcons, SocialIconLink } from "../Footer/FooterElements";

const HorizontalMediaPanel = () => {
  return (
    <div className="fixed-social-links">
      <SocialIcons>
        <SocialIconLink
          href="https://www.facebook.com/profile.php?id=100073267263817"
          target="_blank"
          aria-label="Facebook"
        >
          <FaFacebook></FaFacebook>
        </SocialIconLink>
        <SocialIconLink
          href="https://www.instagram.com/manimaheshessential/"
          target="_blank"
          aria-label="Instagram"
        >
          <FaInstagram></FaInstagram>
        </SocialIconLink>
        {/* <SocialIconLink href="/" target="_blank" aria-label="Twitter">
          <FaTwitter></FaTwitter>
        </SocialIconLink> */}
        <SocialIconLink
          href="https://www.youtube.com/channel/UCjG2vYPh3q9mjsA9-xexg4w"
          target="_blank"
          aria-label="Youtube"
        >
          <FaYoutube></FaYoutube>
        </SocialIconLink>
        <SocialIconLink
          href="https://wa.me/919805043752"
          target="_blank"
          aria-label="Whatsapp"
        >
          <FaWhatsapp></FaWhatsapp>
        </SocialIconLink>
      </SocialIcons>
      {/* <div className="fixed-social-links">
        <link className="twitter">
          <FaTwitter></FaTwitter>
        </link>
        <link className="facebook">
          <FaFacebook></FaFacebook>
        </link>
        <link className="instagram">
          <FaInstagram></FaInstagram>
        </link> */}
      {/* <a href="#" className="google-plus">
          <i className="bx bxl-skype"></i>
        </a> */}
      {/* <link className="linkedin">
          <FaLinkedin></FaLinkedin>
        </link>
      </div>*/}
    </div>
  );
};

export default HorizontalMediaPanel;
